import request from '@/util/bpmRequest'

/**
 * 按条件查询该中心下所有的离职人员
 */
export function pageQueryAll(data) {
  return request({
    url: '/resignation/pageQueryAll',
    method: 'post',
    data
  })
}

/**
 * 通过离职人员的工号获取离职转交记录
 */
export function getResignationsByClientAccount(data) {
  return request({
    url: '/resignation/getResignationsByClientAccount',
    method: 'post',
    data
  })
}

/**
 * 新增离职转交
 */
export function insert(data) {
  return request({
    url: '/resignation/insert',
    method: 'post',
    data
  })
}

/**
 * 删除离职转交
 */
export function entrustmentDelete(data) {
  return request({
    url: '/entrustment/delete',
    method: 'post',
    data
  })
}

/**
 * 批量取消离职转交
 */
export function cancellBatch(data) {
  return request({
    url: '/resignation/cancellBatch',
    method: 'post',
    data
  })
}

// 修改任务委托
export function revise(data) {
  return request({
    url: '/delegation/task/revise',
    method: 'post',
    data
  })
}
